import { connect } from 'react-redux';
import EditUser from './EditUser';

const mapStateToProps = state => ({
  impersonation: state['__global/impersonation'].data.impersonation,
});

export default connect(mapStateToProps)(EditUser);
